module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fundraising"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('router-link', {
    staticClass: "crowd-or",
    attrs: {
      "to": "/crowdfunding"
    }
  }, [_vm._v("CROWDFUNDING")]), _vm._v(" "), _c('span', {
    staticClass: "or"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("FUNDRAISING")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("project.slogan")))]), _vm._v(" "), _c('h2', {
    staticClass: "mb-50"
  }, [_vm._v(_vm._s(_vm.$t("project.chooseCategory")))])]), _vm._v(" "), _c('div', {
    staticClass: "container filters"
  }, [_c('search', {
    attrs: {
      "categories": _vm.categories,
      "type": 'fundraising'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "all-categories mb-30"
  }, [_c('strong', [_vm._v("FUNDRAISING:")]), _vm._v(" " + _vm._s(this.search.category) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      key: project.id
    }, [(_vm.showSpecialists(index)) ? _c('div', _vm._l((_vm.specialistsRow(index)), function(specialist) {
      return _c('specialist-tile', {
        key: specialist.id,
        attrs: {
          "specialist": specialist,
          "size": "col-md-4"
        }
      })
    }), 1) : _vm._e(), _vm._v(" "), _c('fundraising-tile', {
      attrs: {
        "project": project,
        "size": "col-md-4"
      }
    })], 1)
  }), 0), _vm._v(" "), (!_vm.isLast) ? _c('button', {
    staticClass: "btn btn-lg button-more-rais",
    attrs: {
      "disabled": _vm.show_loader,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showMore()
      }
    }
  }, [(!_vm.show_loader) ? _c('span', [_vm._v("  " + _vm._s(_vm.$t("showMore")) + " ")]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.show_loader,
      "color": '#fff',
      "size": '15px'
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "container mb-50"
  }, [_c('div', {
    staticClass: "all-categories"
  }, [_c('strong', [_vm._v("FUNDRAISING:")]), _vm._v(" " + _vm._s(_vm.$t("project.allCategories")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "all-categories-list-rais"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'fundraising',
          query: {
            category_id: category.id,
            category: category.name
          }
        }
      }
    }, [_vm._v(_vm._s(category.name))])], 1)
  }), 0)])]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f56dbac2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Fundraising/Index.vue
// module id = 842
// module chunks = 1